import React from 'react'
import FormattedTime from '@components/FormattedTime'
import { sanitize } from '@utils/sanitize'
import type { Photo } from '@app-types/entity_types'
import type { DerivedMarker } from '@features/horizontal_timeline_core/types/derived_items'

interface ClassicMarkerContentProps {
  marker: DerivedMarker
  photoData: Photo | null
  imageComponent: React.ReactNode
}

const MarkerContent: React.FC<ClassicMarkerContentProps> = ({ marker, imageComponent }) => {
  return (
    <div className="content-holder">
      <div className="content-body">
        {imageComponent}
        <div className="marker-text-content">
          <div className="tooltip-title">
            <FormattedTime dateTime={marker.date} />,{' '}
            <span dangerouslySetInnerHTML={{ __html: sanitize(marker.title) }}></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MarkerContent
